export enum EncounterTypeEligibilityStatus {
  new = 'new',
  eligible = 'eligible',
  ineligible = 'ineligible',
}
